import React from "react";
import { Card, CardContent, Typography, Box, Stack, Button, useMediaQuery } from "@mui/material";

const CustomerPaymentDetails = () => {
  const isDesktop = useMediaQuery("(min-width:900px)");

  // Dummy values (replace later with context, redux, or API data)
  const totalAmount = 100000;
  const downPayment = 25000;
  const nextPayment = totalAmount - downPayment;

  const glassStyle = {
    backdropFilter: "blur(10px)",
    background: "rgba(255, 255, 255, 0.1)",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    borderRadius: "16px",
    boxShadow: "0 6px 20px rgba(0,0,0,0.2)",
    minHeight: isDesktop ? "200px" : "180px",
    width: "100%",
  };

  const textStyle = {
    fontFamily: `'SF Pro Display', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif`,
  };

  return (
    <Stack
      spacing={2}
      sx={{
        maxWidth: isDesktop ? "600px" : "95%",
        mx: "auto",
        mt: isDesktop ? 6 : 3,
        p: isDesktop ? 3 : 1.5,
      }}
    >
      <Card sx={glassStyle}>
        <CardContent sx={{ p: isDesktop ? 4 : 2.5 }}>
          <Box display="flex" flexDirection="column" gap={2}>
            {/* Title */}
            <Typography
              variant={isDesktop ? "h5" : "h6"}
              fontWeight={700}
              sx={{ ...textStyle, textAlign: "center" }}
            >
              Customer Payment Details
            </Typography>

            {/* Payment Info */}
            <Box display="flex" flexDirection="column" gap={1.5}>
              <Typography sx={{ fontSize: isDesktop ? 18 : 16, ...textStyle }}>
                <strong>Total Amount:</strong> ₹{totalAmount.toLocaleString()}
              </Typography>
              <Typography sx={{ fontSize: isDesktop ? 18 : 16, ...textStyle }}>
                <strong>Down Payment:</strong> ₹{downPayment.toLocaleString()}
              </Typography>

              {/* Next Payment + Button (stacked for mobile) */}
              <Box display="flex" flexDirection="column" gap={1} mt={1}>
                <Typography
                  sx={{
                    fontSize: isDesktop ? 20 : 18,
                    ...textStyle,
                    color: "#ff9800",
                    fontWeight: 600,
                  }}
                >
                  Next Payment Due: ₹{nextPayment.toLocaleString()}
                </Typography>

                <Button
                  variant="contained"
                  fullWidth
                  sx={{
                    bgcolor: "#4CAF50",
                    "&:hover": { bgcolor: "#388E3C" },
                    textTransform: "none",
                    fontSize: isDesktop ? 16 : 15,
                    py: 1.2,
                    borderRadius: "12px",
                    fontWeight: 600,
                  }}
                  onClick={() => alert("Proceed to Payment")}
                >
                  Pay Now
                </Button>
              </Box>
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Stack>
  );
};

export default CustomerPaymentDetails;
